import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2'


class GraficaRiesgo extends Component {
	/*Inicializamos todas las variables*/
	constructor (props) {
		super(props);
		this.state = {
			graficaRiesgo: []
		};
	}

	componentDidUpdate = (prevProps) => {
		if(prevProps != this.props){
			if(this.props.data.graficaRiesgo != prevProps.data.graficaRiesgo){
				this.setState({graficaRiesgo: this.props.data.graficaRiesgo})
			}
		}
	}
	
	handleClick = (e) => {
		this.props.parentCallBack(e)
	}
	
	render() {
		const data = {
			labels: ['Alto', 'Medio', 'Bajo'],
			datasets: [
				{
					data: this.state.graficaRiesgo,
					backgroundColor: [
						'rgba(255, 0, 0, 0.5)',
						'rgba(255, 206, 86, 0.5)',
						'rgba(127, 255, 0, 0.5)',
					],
					borderColor: [
						'rgba(255, 0, 0, 1)',
						'rgba(255, 206, 86, 1)',
						'rgba(127, 255, 0, 1)',
					],
					borderWidth: 1,
				},
			],
		}
		const options = {
			onClick: (evt, element) => {
				if(typeof element !== 'undefined' && element.length > 0) {
					const elemntoTablaCurso = document.getElementById('tablaRiesgo');
					elemntoTablaCurso.scrollIntoView({ behavior: 'smooth' });
					this.handleClick(element[0].index)
				}
			},
			plugins:{
				responsive: true,
				tooltip: {
					callbacks: {
						title: function(tooltipItem) {
							return tooltipItem[0].label;
						},
						label: function(tooltipItem) {
							return "Riesgo: " + tooltipItem.raw + " %"
						},
					}
				},
			}
		}
		return (
			<>
				{/* Validando BlackBoard*/}
				{ this.props.data.blackboard.isBlackboard === true ? (
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '40vh'}}>
							<span>Próximamente para Blackboard</span>
						</div>
						<div class="col-md-3"></div>
					</div>
				):(
					<Pie data={data} options={options} />
				)
				}
			</>
		);
	}
}
	
	export default GraficaRiesgo;